import { Check } from "lucide-react";
import { Helmet } from "react-helmet-async";
import { homePage, sharedContent } from "../content/siteContent";
import { ContentSection, JourneyOverview, NewsletterBand, PageHero } from "../components/Sections";
import { SmartLink } from "../components/SiteChrome";

export default function HomePage() {
  return (
    <>
      <Helmet>
        <title>{homePage.seoTitle}</title>
        <meta name="description" content={homePage.seoDescription} />
        <link rel="canonical" href="https://levelup360.pro/" />
        <meta property="og:title" content={homePage.seoTitle} />
        <meta property="og:description" content={homePage.seoDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://levelup360.pro/" />
      </Helmet>
      <PageHero content={homePage.hero} home />
      <ContentSection className="introduction-section" heading={homePage.introduction.heading}>
        <div className="intro-copy">
          {homePage.introduction.paragraphs.map((paragraph) => <p key={paragraph}>{paragraph}</p>)}
        </div>
        <ul className="check-list">
          {homePage.introduction.points.map((point) => <li key={point}><Check aria-hidden="true" /> <span>{point}</span></li>)}
        </ul>
      </ContentSection>
      <JourneyOverview content={homePage.journey} />
      <ContentSection className="govern360-section" tone="mist" heading={homePage.govern360.heading}>
        <p className="section-intro">{homePage.govern360.body}</p>
        <SmartLink className="button button-primary" target={homePage.govern360.cta.target}>{homePage.govern360.cta.label}</SmartLink>
      </ContentSection>
      <ContentSection className="fit-section" tone="light" heading={homePage.fit.heading}>
        <p className="section-intro">{homePage.fit.body}</p>
        <p className="fit-note">{homePage.fit.note}</p>
        <SmartLink className="button button-primary" target={homePage.fit.cta.target}>{homePage.fit.cta.label}</SmartLink>
        <SmartLink className="text-link funding-link" target={homePage.fit.fundingLink.target}>{homePage.fit.fundingLink.label}</SmartLink>
      </ContentSection>
      <NewsletterBand content={sharedContent.newsletter} />
    </>
  );
}
